import * as types from './mutation-types'
import * as constants from '@/mixins/constants'
import Dexie from 'dexie'

Dexie.delete('ro_logs')

const plugin = (store) => {
  var db = new Dexie(constants.DATABASE_NAME)
  db.version(constants.DATABASE_VERSION).stores({
    address:
      '++id,address,lat,lng,short_address,name,mobile,cod,remarks,invalid,types,tracking_number',
    service_types: '++id,_id,name',
    upload_address:
      '++id,file_name,address,lat,lng,short_address,name,mobile,cod,remarks,invalid,types,tracking_number'
  })
  db.version(constants.DATABASE_VERSION + 1).stores({
    address:
      '++id,address,lat,lng,short_address,name,mobile,cod,remarks,invalid,types,tracking_number,[lat+lng]',
    address_data:
      '++id,address,lat,lng,short_address,name,mobile,cod,remarks,invalid,types,tracking_number,[lat+lng]',
    service_types: '++id,_id,name',
    upload_address:
      '++id,file_name,address,lat,lng,short_address,name,mobile,cod,remarks,invalid,types,tracking_number'
  })

  // console.log('store', store, db)
  db.address
    .offset(0)
    .limit(15)
    .toArray()
    .then((addressLogs) => {
      store.dispatch('setAddressList', addressLogs)
    })

  db.service_types
    .offset(0)
    .limit(20)
    .toArray()
    .then((logs) => {
      const currentServices = store.getters.services
      if (logs && logs.length > 0 && (!currentServices || currentServices.length === 0)) {
        store.dispatch('setServiceTypes', logs)
      }
    })

  db.upload_address
    .offset(0)
    .limit(2000)
    .toArray()
    .then((logs) => {
      store.dispatch('setUploadedAddressList', logs)
    })

  db.address_data
    .offset(0)
    .limit(1000)
    .toArray()
    .then((logs) => {
      store.dispatch('setAddressDataList', logs)
    })

  store.subscribe((mutation) => {
    switch (mutation.type) {
      case types.ADD_ADDRESS: {
        const address = mutation.payload
        db.address
          .where('[lat+lng]')
          .equals([address.lat, address.lng])
          .delete()
          .then((count) => {
            console.log('deleted items: ', count)
          })
        db.address.put(mutation.payload)
        break
      }
      case types.SAVE_ADDRESS_DATA: {
        const address = mutation.payload
        db.address_data
          .where('[lat+lng]')
          .equals([address.lat, address.lng])
          .delete()
          .then((count) => {
            console.log('deleted items: ', count)
          })
        db.address_data.put(mutation.payload)
        break
      }
      case types.SET_SERVICE_TYPES:
        if (db.service_types && mutation.payload.data) {
          db.service_types.clear()
          db.service_types.bulkPut(mutation.payload.data)
        }

        break
      case types.SET_UPLOADED_ADDRESS_LIST:
        if (db.upload_address) {
          db.upload_address.bulkPut(mutation.payload)
        }
        break
      case types.REMOVE_BULK_UPLOADED_ADDRESS: {
        const removeIds = mutation.payload.data.map((item) => item.id)
        db.upload_address.bulkDelete(removeIds)
        break
      }
      default:
        break
    }
  })
}

export default plugin
